<template lang="pug">
  .adv-prod-list(:key="category")
    Drawer(v-if="overlay === 'adv-list-view'" @hide="uiStore.hideOverlay()" :title="showProduct.name")
      drawer-contents
        ProductSummary(:productId="parseInt(showProduct.productId, 10)" :show-rhpa="!addToCart")
    h3(v-if="title") {{__(title, 'auto')}}
    slot
    product-carousel(:category="category" :size="size" :products="manualProductList" :filter="filter" :lazy="true")
      template(#product="data")
        button.link.a11y(v-if="viewInfo" @click="showDrawer(data.product)") {{__('See Details', eventNamespace)}}
        advanced-product-list-a2c(v-if="addToCart && isProductValid(data.product)" :productId="getProductId(data.product)")
</template>
<script setup lang="ts">
import { computed, onMounted, onServerPrefetch, ref } from 'vue'
import { eventNamespace } from 'sisu/js/constants'
import { useProductStore } from '@/js/stores/productStore'
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'
import AdvancedProductListA2c from '@/js/components/advanced-product-list-a2c.vue'
import type { Product } from '@/js/services/RogueTypes'

const props = defineProps<{
  category?: string
  filter?: object
  addToCart?: boolean
  viewInfo?: boolean
  title?: string
  productIds?: (string | number)[]
  size?: string
}>()

const productStore = useProductStore()
const uiStore = useUIStore()
const rogue = useRogue()

const showProduct = ref<Product | null>(null)

const overlay = computed<string | null>(() => uiStore.overlay)
const products = computed(() => productStore.products)
const errors = computed(() => productStore.errors)

const ids = computed(() => {
  return props.productIds?.map(value => value.productId || value) || []
})

const loaded = computed(() => {
  return !ids.value.length || ids.value.every(id => products.value[id] || errors.value[id])
})

const manualProductList = computed(() => {
  return ids.value.map(id => products.value[id]).filter(p => !!p)
})

const isProductValid = (product: any) => {
  return product && 
         Object.keys(product).length > 0 && 
         product.productId !== undefined
}

const getProductId = (product: Product) => {
  return parseInt(String(product.productId), 10)
}

async function load() {
  if (!loaded.value && ids.value.length > 0) {
    await productStore.loadAll(ids.value, rogue)
  }
}

function showDrawer(product: any) {
  showProduct.value = product
  uiStore.showOverlay('adv-list-view', rogue)
}

onServerPrefetch(async () => {
  await load()
})

onMounted(() => {
  if (!rogue.ssr) {
    load()
  }
})
</script>
<style lang="scss" scoped>
.adv-list-area {
  cursor: default;
}

.adv-prod-list {
  :deep(.swatches-fixed .swatch-holder) {
    width: 20.0% !important;

    @include mobile() {
      width: 23.0% !important;
    }
  }
}

</style>
